export const TrainingEnum = {
  TAVAN_VINCI: "TAVAN VİNCİ",
  SAC_KESME: "SAC KESME DİLİMLEME / METAL KESİM OPR.",
  DAIRESEL_TESTERE: "DAİRESEL TESTERE / METAL KESİMCİ",
  BAKIM_INSAAT: "M.BAKIMCI / İNŞAATÇI",
  HADDECI: "HADDECİ",
  FORKLIFT: "ENDÜSTRİYEL FORKLİFT, İSTİF MAKİNESİ",
  CNC_TEZGAH: "NC/CNC TEZGAH İŞÇİSİ",
};
